module.exports = __webpack_public_path__ + "img/USER.65f56b20.svg";